import axios from 'axios';
import router from '@/router';

export const SET_TOKEN = (state, token) => {
    state.token = token;
}

export const SET_AUTH_USER = (state, user) => {
    state.authUser = user;
}

export const SET_EMAIL_RESET = (state, email) => {
    state.emailReset = email;
}

export const LOGIN_FAILED = (state, result) => {
	state.loginFailed = result;
}

export const LOG_OUT = (state) => {
    state.token = null;
    state.authUser = null;
    localStorage.clear();
    router.push({ name: 'login' });
    delete axios.defaults.headers.common['Authorization']
}

export const SET_LIST_KEY_AUTH_USER = (state, listKeyAuthUser) => {
    state.listKeyAuthUser = listKeyAuthUser;
}

export const SET_TIMER_COUNTDOWN = (state, timer) => {
  state.timer = timer;
};
